import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CopyLinkItem = ({ item, attribute_set_key }) => {
  const [isNoteCopyUrl, setIsNoteLinkCopy] = useState(false);
  const copynotelinkurl = (item) => {
    setIsNoteLinkCopy(true);

    navigator.clipboard.writeText(
      `${window.location.origin}/tattle/${attribute_set_key}/${
        item?.customer_tattle_uuid
      }#note${item?.custom_note_uuid || item?._id}`
    );
  };
  useEffect(() => {
    setTimeout(() => {
      setIsNoteLinkCopy(false);
    }, 400);
  }, [isNoteCopyUrl]);
  return (
    <OverlayTrigger
      key={"copylink"}
      placement={"top"}
      overlay={
        <Tooltip id={`copy-link`}>
          <strong>Copy</strong>
        </Tooltip>
      }
    >
      <span className="copylinknote" onClick={() => copynotelinkurl(item)}>
        <i className="fa fa-link"></i>
        <label
          className={`copyClaassNote ${
            isNoteCopyUrl ? "copyClaassNoteactive" : ""
          }`}
        >
          Copied
        </label>
      </span>
    </OverlayTrigger>
  );
};

export default CopyLinkItem;
